var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "var(--icon-fill)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2640_73",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "var(--icon-fill)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2640_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.5V15H16.25V17.5H13.75ZM8.75 17.5V15H11.25V17.5H8.75ZM18.75 17.5V15H21.25V17.5H18.75ZM13.75 22.5V20H16.25V22.5H13.75ZM8.75 22.5V20H11.25V22.5H8.75ZM18.75 22.5V20H21.25V22.5H18.75ZM3.75 27.5V5H7.5V2.5H10V5H20V2.5H22.5V5H26.25V27.5H3.75ZM6.25 25H23.75V12.5H6.25V25ZM6.25 10H23.75V7.5H6.25V10Z",
    fill: "var(--icon-fill)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth);
export default __webpack_public_path__ + "static/media/calendar_month.164cf05de508dd90cf0c3e64e873237f.svg";
export { ForwardRef as ReactComponent };